import { render, staticRenderFns } from "./SectorsAdd.vue?vue&type=template&id=e6bfd8ac&scoped=true&"
import script from "./SectorsAdd.vue?vue&type=script&lang=js&"
export * from "./SectorsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bfd8ac",
  null
  
)

export default component.exports